import '@ant-design/compatible/assets/index.css';
import { CloseOutlined } from '@ant-design/icons';
import PropTypes from 'prop-types';
import React from 'react';
import modal from '~components/modal';
import PaymentPreferenceEditor from './editor';

@modal(
  {
    className: 'partner-register-city-editor-modal',
  },
  true,
)
class PaymentPreferenceEditorContainer extends React.Component {
  constructor(props) {
    super(props);
  }

  render() {
    const { editParams } = this.props;

    return (
      <div className="partner-register-city-editor">
        <div className="partner-register-city-editor__header" style={{ paddingBottom: '24px' }}>
          Edit Payment Preference
          <CloseOutlined
            className="partner-register-city-editor__close-button"
            onClick={this.props.handleCloseModal}
          />
        </div>
        <PaymentPreferenceEditor
          partnerId={editParams.partnerId}
          paymentPreference={editParams.paymentPreference}
          partnerCountrySlug={editParams.partnerCountrySlug}
          onClose={this.props.handleCloseModal}
        />
      </div>
    );
  }
}

PaymentPreferenceEditorContainer.propTypes = {
  t: PropTypes.func.isRequired,
  editParams: PropTypes.object.isRequired,
  handleCloseModal: PropTypes.func.isRequired,
};

PaymentPreferenceEditorContainer.defaultProps = {
  t: () => {},
  editParams: {},
  handleCloseModal: () => {},
};

export default PaymentPreferenceEditorContainer;
